import { MintStatus as MintStatusEnum } from '../gaslessMintEntities'
import { ArpMedia } from './ArpMedia'
import { BaseModel } from './common'
import { MintExtras } from './MintExtras'
import { User } from './User'

export enum MintOrigin {
  STUDIO = 'studio',
  UPLOAD_SOUND = 'upload_sound',
  UPLOAD_SONG = 'upload_song',
  EXTERNAL = 'external'
}

export interface MintStatusModel extends BaseModel {
  jobId: string
  arpeggiComposition: any
  userId: number
  user: User
  mintStatus: MintStatusEnum
  metadata: any
  tokenContractAddress: string
  sqsMessage?: string
  sqsMessageSound?: string
  tokenId?: number
  arpMediaId?: number
  samples?: ArpMedia[]
  subComponents?: ArpMedia[]
  mintOrigin: MintOrigin
  mintExtras?: MintExtras
}
